import { Account } from '@mews-commander/data-access';
import { Typography } from '@optimus-web/core';
import { EnterpriseLink } from '@mews-commander/ui';
import { AccountName } from '../../../../../../../components';
import { DividedList } from './DividedList';

interface CompanionNameListProps {
    accounts: Record<string, Account>;
    companionIds: string[];
}

export const CompanionNameList = ({ accounts, companionIds }: CompanionNameListProps) => (
    <DividedList
        collectionIds={companionIds}
        renderItem={(id) => {
            const account = accounts?.[id];

            if (!account) return null;

            return (
                <Typography whiteSpace="nowrap" textStyle="bodyMedium" as="div">
                    <EnterpriseLink to="Customer/Detail/$id" params={{ id: account.id }} inherit>
                        <AccountName account={account} />
                    </EnterpriseLink>
                </Typography>
            );
        }}
    />
);
